import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Typography from '@material-ui/core/Typography'
import { makeStyles, ThemeProvider } from '@material-ui/styles'
import { useStoryblokEditable } from '@sb-konzept/gatsby-source-storyblok'
import React from 'react'

const lightTheme = (cols) => ({
  overrides: {
    MuiTableCell: {
      root: {
        backgroundColor: 'transparent',
        padding: '4px 6px',
        width: `${100 / cols}%`,
        color: 'inherit',
        borderBottom: 'none',
        textAlign: 'center'
      },
      head: {
        backgroundColor: 'transparent',
        color: '#8f8f8f',
        fontWeight: 700
      },
      body: {
        color: 'inherit'
      }
    }
  }
})

const darkTheme = {
  overrides: {
    MuiTableCell: {
      root: {
        backgroundColor: '#242424',
        padding: '14px 6px',
        height: '8vh',
        width: '11.11%',
        color: 'inherit',
        borderBottom: 'none',
        textAlign: 'center'
      },
      head: {
        backgroundColor: '#333738',
        color: '#afafaf'
      },
      body: {
        color: '#ffffff',
        fontStyle: 'italic',
        borderBottom: '1px solid #70707088'
      }
    }
  }
}

const useStyles = makeStyles((theme) => ({
  headerLight: {
    backgroundColor: '#3a3e3f'
  },
  headerDark: {
    backgroundColor: '#333738'
  },
  bodyLight: {
    backgroundColor: '#2c2c2e'
  },
  bodyDark: {
    backgroundColor: '#242424'
  },
  firstColumn: {
    backgroundColor: '#252525',
    color: '#b2aeae',
    fontStyle: 'normal',
    border: 'none',
    whiteSpace: 'nowrap',
    padding: '14px 6px',
    width: '11.11%'
    // padding: "14px 24px"
  },
  specialCell: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.text.primary
  }
}))

function StoryblokTable(props) {
  const { content } = props
  const { editableProps } = useStoryblokEditable()
  const { data, theme, italicColumns, hideHead, dense, specialCell, title } = // content[0];
    content[0] || content
  const classes = useStyles(props)
  const themeObject =
    theme === 'lightTheme' ? lightTheme(data.thead.length) : darkTheme

  const italic = italicColumns?.split(',').map((r) => r - 1)
  // Get the list of co-ordinates, remove the spaces, store as array elements
  const specialCells = specialCell
    ?.match(/\(\d,\s?\d\)/g)
    ?.map((m) => m.replace(' ', ''))

  return (
    <ThemeProvider theme={themeObject}>
      <Typography
        align="center"
        color="textPrimary"
        component="h4"
        variant="h4"
      >
        {title}
      </Typography>
      <Table padding={dense ? 'dense' : 'default'} {...editableProps}>
        {!hideHead && (
          <TableHead>
            <TableRow>
              {data.thead?.map(({ value }, idx) => (
                <TableCell
                  key={idx}
                  className={
                    specialCells?.indexOf(`(${idx},0)`) > -1
                      ? classes.specialCell
                      : theme === 'darkTheme'
                      ? idx < 1
                        ? classes.firstColumn
                        : idx % 2 !== 0
                        ? classes.headerLight
                        : classes.headerDark
                      : null
                  }
                  variant="head"
                >
                  {/* {console.log("TABLE", value, idx, specialCells)} */}
                  {value}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
        )}
        <TableBody>
          {data.tbody?.map((row, ridx) => (
            <TableRow key={row._uid}>
              {row.body.map((col, idx) => {
                const coords = `(${idx},${ridx + 1})` // Ensure co-ordinates start at 0,0 (excluding head)
                return (
                  <TableCell
                    key={col._uid}
                    // Test the specialCells array to see if the co-ordinates are in there
                    className={
                      specialCells?.indexOf(coords) > -1
                        ? classes.specialCell
                        : theme === 'darkTheme'
                        ? idx < 1
                          ? classes.firstColumn
                          : idx % 2 === 0
                          ? classes.bodyDark
                          : classes.bodyLight
                        : null
                    }
                    variant="body"
                  >
                    {italic?.includes(idx) ? <em>{col.value}</em> : col.value}
                  </TableCell>
                )
              })}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </ThemeProvider>
  )
}

export default StoryblokTable
